import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import AlternativeDesign from '../AlternativeDesign';

const DesignSelection = ({
  close,
  closeWithoutSaving,
  alternativeDesigns,
  description,
  designPriceFormatted,
  prefix,
  selectedTemplateId,
  selectTemplateId,
  priceMessage,
  priceDifference,
  formattedPriceDifference,
  isDuplicate,
  template,
  textStyle,
}) => (
  <div className={styles.designSelection}>
    <div className={styles.designInner}>
      <span className={styles.description}>
        <span>{prefix}:</span> {description} ({designPriceFormatted})
      </span>
      <span className={styles.priceChange}>
        {priceMessage} {priceDifference ? formattedPriceDifference : ''}
      </span>
      <span className={styles.options}>
        {alternativeDesigns.map(ad => (
          <AlternativeDesign
            key={ad.id}
            alternativeTemplateId={ad.templateId}
            selectedTemplateId={selectedTemplateId}
            selectTemplateId={selectTemplateId}
            code={ad.id}
            imageUrl={ad.iconImgUrl}
            isDuplicate={isDuplicate}
          />
        ))}
      </span>
      <span
        className={styles.saveButton}
        style={textStyle}
        onTouchEnd={close}
        onClick={close}
      >
        Save
      </span>
      <div
        className={styles.outerArea}
        onClick={closeWithoutSaving}
        onTouchEnd={closeWithoutSaving}
      />
    </div>
  </div>
);

export default enhance(DesignSelection);
